import { ErrorHandler, Injectable } from '@angular/core';

import { AppError } from 'src/app/core/models/app-error.model';

@Injectable()
export class ErrorInterceptor implements ErrorHandler {

	constructor() {}

	handleError(error: AppError | Error) {

		if (error instanceof AppError) {

			// Client-side error.
			console.error(error.message);

		} else if (error instanceof Error) {

			// Client-side error.
			console.error(error.message);

		}

	}

}
